import { IToolbarActionDefinition } from "../../../../utils/emails";
import { IMenuItem } from "../../components/Menu";
import { callbackAsPromise } from "../../../../lib/Promises";

export class MenuItemAdapter implements IMenuItem<MenuItemAdapter>
{
    action: IToolbarActionDefinition;
    onClick?: (() => void) | undefined;

    constructor(action: IToolbarActionDefinition)
    {
        this.action = action;
    }

    get text() { return this.action.text ?? ''; }

    get icon() { return this.action.icon; }

    get selectable() { return this.action.onSelected != null; }

    get hasChildren() { return this.action.loadChildren != null; }

    async loadChildren()
    {
        if (!this.action.loadChildren) { return []; }
        const children = await callbackAsPromise(this.action.loadChildren.bind(this));
        return children.map(child => new MenuItemAdapter(child));
    }
}